import { Card, CardType } from '@generated-types';
import { cardTypeGet } from '@utils/query-utils';

import { REST_BASE_URL_DEBIT_CARDS } from '../common';

export const getOwnDebitCards = async () =>
    cardTypeGet(CardType.DEBIT)<Card[]>(`${REST_BASE_URL_DEBIT_CARDS}`, new URLSearchParams([['ownership', 'OWN']]));

export const getRelatedDebitCards = async () =>
    cardTypeGet(CardType.DEBIT)<Card[]>(
        `${REST_BASE_URL_DEBIT_CARDS}`,
        new URLSearchParams([['ownership', 'RELATED']]),
    );
